import Button from '@mui/material/Button';
import { Link } from 'react-router-dom';
import { stringify } from 'query-string';
import { FieldProps, useRecordContext } from 'react-admin';


export const ShowMessagesButton = (props:Omit<FieldProps, "source">) => {
    const record = useRecordContext(props)
    const handleClick = (e: any) => {
        e.stopPropagation();
    }

    return record ? (
        <Button
            
            size='small'
            variant="outlined"
            color="primary"
            target="_blank"
            rel="noopener"
            onClick={handleClick}
            component={Link}
            to={{
                pathname: '/message',
                search: stringify({
                    filter: JSON.stringify({ "sender|to": record.id })
                }),
            }}
            {...props}
        >
            Open
        </Button>
    ) : null;
};
